export default "__VITE_ASSET__D0ioacLr__"